import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserPasswordRecoverInterface } from "../../../middleware/interfaces/user/user-password-recover-interface";

export const UserPasswordRecover = {
  Recover: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const passwordRecoverData: UserPasswordRecoverInterface = state.data;
      const url = "./php/user/user-password-recoverer-proxy.php";
      await axios
        .post(url, passwordRecoverData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
